import { createFileRoute } from '@tanstack/react-router';
import { AuditConsolePage } from '@/pages/settings/audit/AuditConsolePage';

export const Route = createFileRoute('/_authenticated/_app/settings/audit/')({
	component: AuditConsolePage,
});
